import { ChangeDetectorRef, Component, Inject, OnDestroy, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DirtyComponent } from '../../helpers/CanDeactivate/dirty-component';
import { TranslateService } from '@ngx-translate/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgxScannerQrcodeComponent } from 'ngx-scanner-qrcode';
import { VendorOffersService } from '../../features/Vendor-Admin/vendor-offers/services/vendor-offers.service';
import { AuthenticationService } from '../../services/authentication.service';
import { ClaimedPointOfferService } from './services/claimPointOffer.service';
import Swal from 'sweetalert2';

export interface DialogData {
  vendor_id: any,
  CamerasListIds: any[],
  branches: any[]
}
@Component({
  selector: 'app-claim-point-offer',
  templateUrl: './claim-point-offer.component.html',
  styles: ``
})
export class ClaimPointOfferComponent extends DirtyComponent implements OnDestroy {

  @ViewChild('action') action!: NgxScannerQrcodeComponent;
  actionApplied = false;

  override formGroup!: FormGroup;
  dataLoading = false;
  loading = false;
  isSubmitted = false;
  BranchesList: any[] = []

  AllowToggel: boolean = false;
  CamerasListIds = this.data.CamerasListIds;
  CurrentCameraIndex = 0;
  devicesList: any = [];

  videoStream: MediaStream | null = null;

  constructor(
    override dialogRef: MatDialogRef<ClaimPointOfferComponent>,
    private formBuilder: FormBuilder,
    translate: TranslateService,
    private service: ClaimedPointOfferService,
    private cdr: ChangeDetectorRef,
    private _VendorOffersService: VendorOffersService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,) {
    super(translate);
  }

  ngOnInit(): void {
    this.buildForm();
    // setTimeout(() => {
    //   this.getBranches();
    // }, 1000);
    // setTimeout(() => {
    //   this.getBranches();
    // }, 1000);

    // this._VendorOffersService.vendorBranches.subscribe(branches => {
    //   this.BranchesList = branches;
    // })
  }

  scannerLoader = true;
  ngAfterViewInit(): void {
    this.action.start();
    setTimeout(() => {
      const devices = this.action.devices.value;
      const device = devices.find(f => (/back|trás|rear|traseira|environment|ambiente/gi.test(f.label))) ?? devices.pop();
      if (device) {
        this.action?.playDevice(device.deviceId);
        this.CurrentCameraIndex = devices.length - 1;
      }
      this.scannerLoader = false;
    }, 1000);
    this.cdr.detectChanges();
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      code: [
        null,
        [Validators.required]
      ],
      branch_id: [
        null,
        [Validators.required]
      ]
    });
  }

  hasError(controlName: string, errorName: string) {
    return this.formGroup.controls[controlName].hasError(errorName);
  }

  cancelPop() {
    if (!this.canDeactivate()) {
      // this.action.stop();
      this.handle(this.action, 'stop')
    }
    this.stopTracks(this.action)
    this.handle(this.action, 'stop');
    this.action.stop();
    this.action.stop()
  }


  applyAction(event: any = null) {
    // this.action.playDevice(event)
    // this.action.stop();
    this.handle(this.action, 'stop')
    this.actionApplied = true;
    this.formGroup.controls['code'].setValue(event[0]?.value);
  }

  ClaimOfferOrPoint() {
    this.isSubmitted = true;
    if (this.formGroup.valid) {
      this.loading = true;
      let data = this.formGroup.value;

      this.service.ClaimOfferOrPoint(data).subscribe((res) => {
        this.loading = false;
        let title = '';
        let html = '';
        let button = ''
        if (res.status == 1906) {
          title = this.translate.instant('ClaimPointOrOffer.The offer has been claimed successfully');
          html = `<p class="font-14 fontRegular grey-color mb-1 text-center">${this.translate.instant('ClaimPointOrOffer.Claimed offer')}</p>
          <div class="name-with-image small-wide-img with-bg">
          <div class="image-square">
            <img src="${res.data.offer.image}">
          </div>
          <div class="name">
            <h5 class="font-16 fontRegular text-color">
              ${res.data.offer.name}
            </h5>
          </div>
          </div>`;
          button = this.translate.instant('swalMsg.Ok');
        } else if (res.status == 1907) {
          title = this.translate.instant('ClaimPointOrOffer.Points have been claimed successfully');
          html = `<p class="font-14 fontRegular grey-color mb-1 text-center">${this.translate.instant('employeeProfile.Replaced Points')}</p>
          <p class="font-22 fontBold greenColor">${res.data.points} <span class="font-22 fontRegular greenColor">${this.translate.instant('companyAdminProfile.point')}</span></p>`;
          button = this.translate.instant('swalMsg.Ok');
        }
        Swal.fire({
          title: title,
          text: '',
          html: html,
          imageUrl: './assets/images/icons/success.svg',
          confirmButtonText: this.translate.instant('swalMsg.Ok')
        });
        this.dialogRef.close([true]);
        this.applyAction(this.action);
        this.service.RefreshWallet.next(true);
        setTimeout(() => {
          this.service.RefreshWallet.next(false);
        }, 1000);
      }, error => {
        this.loading = false;
        let title = '';
        let html = '';
        let button = '';

        if (error.status == 1904) {
          title = this.translate.instant('ClaimPointOrOffer.The entered code is invalid');
          html = `<p class="font-14 fontRegular grey-color mb-0">${this.translate.instant('ClaimPointOrOffer.Please try again')}</p>`
          button = this.translate.instant('ClaimPointOrOffer.Try again');
        } else if (error.status == 1905) {
          title = this.translate.instant('ClaimPointOrOffer.This code has been claimed before');
          button = this.translate.instant('swalMsg.Ok');
        } else if (error.status == 1903) {
          title = error.errors[0].massage;
          html = `<p class="font-14 fontRegular grey-color mb-1 text-center">${this.translate.instant('employeeProfile.The Offer')}</p>
          <div class="name-with-image small-wide-img with-bg">
          <div class="image-square">
            <img src="${error.data.offer.image}">
          </div>
          <div class="name">
            <h5 class="font-16 fontRegular text-color">
              ${error.data.offer.name}
            </h5>
          </div>
          </div>`;
          button = this.translate.instant('swalMsg.Ok');
        } else if (error.status == 1901) {
          let branches = '';
          error.data.branches.forEach((element: any) => {
            branches += `<li><span>${element.branch_name}</span></li>`
          })
          title = error.errors[0].massage;
          html = `<p class="font-14 fontRegular grey-color mb-1 text-center">${this.translate.instant('employeeProfile.The Offer')}</p>
          <div class="name-with-image small-wide-img with-bg">
          <div class="image-square">
            <img src="${error.data.offer.image}">
          </div>
          <div class="name">
            <h5 class="font-16 fontRegular text-color">
              ${error.data.offer.name}
            </h5>
          </div>
          </div>
          <p class="font-14 fontRegular grey-color mb-1 text-center mt-3">${this.translate.instant('ClaimPointOrOffer.This offer is only valid in these branches')}</p>
          <ul class="ul-bg">
            ${branches}
          </ul>
          `;
          button = this.translate.instant('swalMsg.Ok');
        }
        // error.errors[0].massage
        Swal.fire({
          title: title,
          text: '',
          html: html,
          imageUrl: './assets/images/icons/warning-ic.svg',
          confirmButtonText: button
        });
        this.dialogRef.close([true]);
        this.applyAction(this.action);
      })
    }
  }

  getBranches() {
    this.dataLoading = true;
    let offerId = null;
    this._VendorOffersService.getBranchesForVendor(this.data?.vendor_id, offerId).subscribe((res) => {
      this.dataLoading = false;
      this._VendorOffersService.vendorBranches.next(res.data);
      this.BranchesList = res.data;
      // this.branchesList = res.data;
      // this.branchesCount = res.data.total;
    }, (error: any) => {
      this.dataLoading = false;
    }
    )
  }

  ToggelCamera() {
    if (this.CurrentCameraIndex == this.CamerasListIds.length - 1) {
      this.CurrentCameraIndex = 0;
    } else {
      this.CurrentCameraIndex += 1;
    }
    this.action?.playDevice(this.CamerasListIds[this.CurrentCameraIndex].deviceId);
  }
  stopTracks(stram: any) {
    stram.video.nativeElement.srcObject = null;
    (navigator as any).getUserMedia({ audio: false, video: true },
      function (stream: any) {
        // can also use getAudioTracks() or getVideoTracks()
        var track = stream.getTracks()[0];  // if only one media track
        // ...
        track.stop();
      },
      function (error: any) {
        console.log('getUserMedia() error', error);
      });
    // navigator.mediaDevices.getUserMedia({ video: true }).then((mediaStream) => {
    //   stram.video.nativeElement.srcObject = mediaStream;
    //   // Stop the stream after 5 seconds
    //   // setTimeout(() => {
    //   //   const tracks = mediaStream.getTracks();
    //   //   tracks[0].stop();
    //   // }, 10);
    //   mediaStream.getTracks().forEach(function (track) {
    //     track.stop();
    //   });
    // });
    // stream.getTracks().forEach(function(track) {
    //   track.stop();
    // });

  }

  // stopTracks(stram: any) {
  //   stram.video.nativeElement.srcObject.getTracks().forEach((track: any) => {
  //     track.stop();
  //   })
  //   stram.video.nativeElement.srcObject = null;
  // }

  handle(action: any, fn: string): void {
    action[fn]();
  }

  ngOnDestroy(): void {
    this.applyAction(this.action);
    this.stopTracks(this.action);
  }
  started() {
    alert();
  }
}
